import React from "react";

const qrbullets = {
  marginLeft: -15,
  marginTop: -8,
};

const mySection = {
  width: "100vw",
  minHeight: "800px",
  backgroundImage: "url('assets/images/auth-bg.jpg')",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: 0,
  marginTop: 0,
  position: "relative",
  display: "flex",
  alignItems: "center",
};

//const featurePhone = { top: "270px", left: "200px" };

class Aboutcompany extends React.Component {
  render() {
    return (
      <section
        //className="feature"
        style={mySection}
      >
        {/* id and classname was feature */}
        <div className="feature-decor">
          <div className="feature-circle1">
            <img src="assets/images/feature2.png" alt="" />
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 d-medium-none" id="about-hide">
              <img
                src="assets/images/etaireia-logo1.png"
                className="img-fluid"
                alt=""
                style={{
                  top: 120,
                  right: 30,
                  position: "absolute",
                }}
              />
            </div>
            <div className="offset-lg-4 col-lg-8">
              <div className="row">
                <div className="col-sm-12 mrgn-md-top">
                  <h2 className="title">
                    <span>ΕΤΑΙΡΙΚΟ ΠΡΟΦΙΛ</span>
                  </h2>
                  <p>
                    Mε σεβασμό και αίσθημα Εταιρικής Κοινωνικής Ευθύνης, η
                    QRSTAND διαθέτει την εμπειρία, την απαραίτητη τεχνογνωσία,
                    καταρτισμένο προσωπικό και το κατάλληλο δίκτυο συνεργατών
                    και δημοσίων σχέσεων, ώστε να διασφαλίζει την άρτια και
                    επιτυχημένη διεκπεραίωση των έργων που αναλαμβάνει.
                  </p>
                  <p>
                    Η εταιρία QRSTAND IKE δραστηριοποιείται στους παρακάτω
                    βασικούς άξονες.
                  </p>
                </div>
                <div className="col-12 col-md-6">
                  <ul className="feature-style">
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>Την οργάνωση εμπορικών εκθέσεων και εκδηλώσεων</h3>
                      </div>
                    </li>
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>Την κατασκευή εκθεσιακών περιπτέρων</h3>
                      </div>
                    </li>
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>
                          Την παροχή καινοτόμων τεχνολογικών υπηρεσιών με
                          γνώμονα τις ανάγκες της εποχής.
                        </h3>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-md-6 sm-m-top">
                  <ul className="feature-style">
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>
                          Την ανακαίνιση κάθε είδους επαγγελματικού χώρου.
                        </h3>
                      </div>
                    </li>
                    <li>
                      <div className="feature-icon">
                        <img
                          src="assets/images/qr-stand-logo-icon.png"
                          alt="Awasome-Design"
                          style={qrbullets}
                        />
                      </div>
                      <div className="feature-subtitle">
                        <h3>Την ανακαίνιση της οικίας σας.</h3>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Aboutcompany;



// WEBPACK FOOTER //
// ./src/components/aboutcompany.js